/** What the Vendor Returns "new return" form sends to POST /vendor-returns (server wants `qty`, not `quantity`). */
export interface NewVendorReturnRow {
  productId: string;
  productName: string;
  quantity: number;
  unit: string;
  rate: number;
  reason: string;
  qcPhotos: string[];
}

/** Rate for a picked product: its cost price. Not shown to roles the server hides cost from -> 0, user types it. */
export function costRate(p: { costPrice?: number | string | null }): number {
  const n = Number(p.costPrice);
  return p.costPrice != null && p.costPrice !== '' && Number.isFinite(n) && n >= 0 ? n : 0;
}

export function buildVendorReturnBody(vendorId: string, vendorName: string, notes: string, rows: NewVendorReturnRow[]) {
  return {
    vendorId,
    vendorName,
    type: rows[0]?.reason || 'defective',
    notes: notes || null,
    items: rows.map((r) => ({
      productId: r.productId,
      productName: r.productName,
      qty: r.quantity,
      unit: r.unit,
      rate: r.rate,
      reason: r.reason,
      qcPhotos: r.qcPhotos,
    })),
  };
}
